exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".keyVal{align-items:center;display:flex;flex-direction:row;justify-content:space-between;margin:8px}.keyVal_key{font-weight:bold}\n", ""]);

